// import { Injectable, Injector } from '@angular/core';
// import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
// import { Observable } from 'rxjs';
// import { throwError } from 'rxjs';
// import { catchError } from 'rxjs/operators';
// // import { CookiesStorageService, LocalStorageService, SessionStorageService, SharedStorageService } from "ngx-store";
// import { Router } from '@angular/router';
// import {
//   UmsService
// } from '../app/ums.service';

// @Injectable()
// export class HttpTokenInterceptorService implements HttpInterceptor {
//     constructor(
//         private restApiService: UmsService,
//         private router: Router) { }

//     redirect(to): void {
//         this.router.navigate([to]);
//     }
//     loginExpiredNotifier(): void {
//         this.restApiService.openSnackbar('Your login session expired. Please Re-login to continue');
//     }
//     isTokenValid(token: string): boolean {
//         return token !== undefined && token !== null && token !== '';
//     }
    
//     intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
//         let token = sessionStorage.getItem('token');
//     //
 
//         // if (token === undefined || token == null || token === '' && !this.router.url.includes('student-registration')) {

//         //     token = 'noToken';
//         //     this.router.navigate(['student-login']);
//         // }
        
//         // Usage in your condition
     
//          if(!this.isTokenValid(token) && this.router.url.includes('student-registration')){
//             token = 'noToken';
//         }
//         else if(!this.isTokenValid(token) && this.router.url.includes('certificate-login')){
//             token = 'noToken';
//             this.router.navigate(['certificate-login']);

//         }
//         else if (!this.isTokenValid(token) && this.router.url.includes('student-login')) {
//             token = 'noToken';
//             this.router.navigate(['student-login']);

//         }
//         else if(!this.isTokenValid(token)){
//             token = 'noToken';
            
//         }
//         const authReq = req.clone({ headers: req.headers.set('token', token) });
//         return next.handle(authReq).pipe(
//             catchError((error, caught) => {
//                 if (error.status === 401) {
//                   sessionStorage.setItem('token', 'noToken');
//                     // this.loginExpiredNotifier();
//                 //   this.router.navigate(['student-login']); // remember to import router class and declare it in the class
//                   return throwError(error);
//                 } else {
//                     return throwError(error);
//                 }
//             }) as any
//         );

//     }
// }




import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError,tap} from 'rxjs/operators';
import * as crc32 from "crc-32";
// import { CookiesStorageService, LocalStorageService, SessionStorageService, SharedStorageService } from "ngx-store";
import { Router } from '@angular/router';
import {
  UmsService
} from '../app/ums.service';

@Injectable()
export class HttpTokenInterceptorService implements HttpInterceptor {
    crcSecrateKey: string = "SABSUKHLAHETUMHARISARNATUMRAKSHAKKAHUKODARNA";
    constructor(
        private restApiService: UmsService,
        private router: Router) { }

    redirect(to): void {
        this.router.navigate([to]);
    }
    loginExpiredNotifier(): void {
        this.restApiService.openSnackbar('Your login session expired. Please Re-login to continue');
    }
    isTokenValid(token: string): boolean {
        return token !== undefined && token !== null && token !== '';
    }
    
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let token = sessionStorage.getItem('token');
        if (token === undefined || token == null || token === '') {
            token = 'noToken';
        //     this.router.navigate(['student-login']);
          }
          let headersdata = new HttpHeaders({
            Accept: "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, OPTIONS, DELETE, PUT",
            "Access-Control-Allow-Credentials": "true",
            "Access-Control-Allow-Headers": "access-control-allow-ums",
            "Access-Control-Expose-Headers": "access-control-allow-ums",
          });
          if (req.method === "POST" || req.method === "PATCH" || req.method === "PUT" || req.method === "DELETE") {
            const jsonString = JSON.stringify(req.body);
            const dataWithSecret = jsonString + "this.crcSecrateKey";
            const crcValue: string = crc32.str(dataWithSecret).toString(16);
            headersdata = headersdata.set("access-control-allow-ums", crcValue);
          }
          if (req.method === "GET") {
            let params = req.url.split('?')[1]?.split('&').reduce((acc, key) => {
              const valuObj = key.split('=');
              acc[valuObj[0]] = valuObj[1] || '';
              return acc;
            }, {}) || {};
            const jsonString = JSON.stringify(params);
            const dataWithSecret = jsonString + this.crcSecrateKey;
            const crcValue: string = crc32.str(dataWithSecret).toString(16);
            headersdata = headersdata.set("access-control-allow-ums", crcValue);
          }
          headersdata = headersdata.set("token", token);
          const modifiedReq = req.clone({ headers: headersdata });
          return next.handle(modifiedReq).pipe(
            tap(event => {
              if (event instanceof HttpResponse) {
                const ResponseCrcValue = event.headers.get('access-control-allow-ums');
                const jsonString = JSON.stringify(event.body);
                const dataWithSecret = jsonString + this.crcSecrateKey;
                const crcValue: string = crc32.str(dataWithSecret).toString(16);
                if (ResponseCrcValue !== null && ResponseCrcValue !== '' && ResponseCrcValue !== undefined) {
                  if (!event.url.includes('localhost') && ResponseCrcValue != crcValue) {
                    sessionStorage.clear();
                    alert('Invalid Access.Your been redirected out');
                    window.location.href = 'https://www.google.com/';
                    localStorage.removeItem('isAppOpen');
     
                  }
                }
              }
            }),
            catchError((error, caught) => {
                if (error.status === 401 || error.status === 409) {
                  (window as any).storeItem("token", "noToken");
                  // this.loginExpiredNotifier();
                //   this.router.navigate(["login"]); // remember to import router class and declare it in the class
         if(!this.isTokenValid(token) && this.router.url.includes('student-registration')){
            token = 'noToken';
        }
                else if (!this.isTokenValid(token)) {
            token = 'noToken';
            this.router.navigate(['student-login']);
        }
                  return throwError(error);
                } else {
                    return throwError(error);
                }
            }) as any
        );

    //
 
        // if (token === undefined || token == null || token === '' && !this.router.url.includes('student-registration')) {

        //     token = 'noToken';
        //     this.router.navigate(['student-login']);
        // }
        
        // Usage in your condition
     
        //  if(!this.isTokenValid(token) && this.router.url.includes('student-registration')){
        //     token = 'noToken';
        // }
        // else if (!this.isTokenValid(token)) {
        //     token = 'noToken';
        //     this.router.navigate(['student-login']);
        // }
        // const authReq = req.clone({ headers: req.headers.set('token', token) });
        // return next.handle(authReq).pipe(
        //     catchError((error, caught) => {
        //         if (error.status === 401) {
        //           sessionStorage.setItem('token', 'noToken');
        //           return throwError(error);
        //         } else {
        //             return throwError(error);
        //         }
        //     }) as any
        // );

    }
}